import { createContext } from "react";
 
const intialValues = {};
 
export const MasterConfigContext = createContext(intialValues);
 
 